
import '../pages/Gachapon.scss';
import { DateTime } from "luxon"

const SpinsItem = ({spinData}: {spinData: any}) => {
  
    return (
        <div className={`LastSpins--Item LastSpins--Item-${spinData.tier}`}>
            <div className="Spins--Item--Img">
               {false && <span>{spinData.tier !== "tier2023" ? `Rabbit SPIN`: `Paid spin`}</span>}
              <img src={spinData.src} />
            </div>
            <div className="LastSpins--Item--Title">
                <span className='LastSpins--Item--Wallet'>{spinData.prize} <a target={`_blank`} title={'View on Solscan'} href={`https://solscan.io/token/${spinData.mint}`}><img  src={`/thumbnails/solscan.svg`}/></a></span>
                <span className='LastSpins--Item--Prize'>{spinData.wallet}</span> 
            </div>
            <span className='LastSpins--Item--Time'>{DateTime.fromISO(spinData.time).toRelative({style: "narrow"})}</span>
        </div>
    )
}
const hideWallet = (wallet:string) => {
    return `${wallet.slice(0, 4)}...${wallet.substr(40,4)}`
  }
const LastSpins = ({lastSpins}: {lastSpins:any}) => {
    
    return (
        <div className="LastSpins--Container">
            <div className="LastSpins--Title">LUCKY wINNERS</div>
            <div className="LastSpins--Items">
                {lastSpins && lastSpins.map((item:any, index:number) => {
          
                   const responseData = {image: "", name: "", type: item.prize_tier}
                   if(item.prize_tier.indexOf("exp_") === 0){
                    responseData.image = `/thumbnails/${item.prize_tier}.png`
                    let xpName = item.prize_tier.split("exp_")
                    responseData.name = `${xpName[1]} EXP`
                  } else if (item.prize_tier === "level_up"){
                    responseData.image = `/thumbnails/level_up.png`
                    responseData.name = `Level UP`
                  } else if (item.prize_tier === "spl_token"){
                    let splName = item.mint_name
                    let splImage = "spl_token"
                    switch (item.mint_name) {
                      case "FRRT":
                        splName = "Raffle Ticket"
                        splImage = "raffle_tickets"
                        break;
                      case "FRGS":
                        splName = "Spin Token"
                        splImage = "spin_token"
                        break;
                    
                      default:
                        splName = item.mint_name
                        splImage = "spl_token"
                        break;
                    }
                    var tokenName = splName
                    responseData.image = `/thumbnails/${splImage}.png`
                    responseData.name = `${item.amount} ${tokenName}`
                  } else if(item.nft){
                    responseData.image = `${item.nft.metadata.image}`
                    responseData.name = item.nft.metadata.name
                  } else if (item.prize_tier === "wl_spot"){
                    responseData.image = `/thumbnails/wl_spot.png`
                    responseData.name = `WL Spot`
                  } else if (item.prize_tier === "fragment"){
                    responseData.image = `/thumbnails/fragment.png`
                    responseData.name = `Spin Fragment`
                  } else if (item.prize_tier === "digital_good"){
                    responseData.image = `/thumbnails/digital_good.png`
                    responseData.name = `Digital Good`
                  } else if (item.prize_tier === "raffle_ticket"){
                    responseData.image = `/thumbnails/raffle_tickets.png`
                    responseData.name = `Raffle Ticket`
                  } else {
                    responseData.image = `/thumbnails/flippinrabbits.png`
                    responseData.name = "Gachapon Prize"
                  }

                   var spinData = {
                        src: responseData.image, 
                        wallet: hideWallet(item.wallet), 
                        prize: responseData.name, 
                        tier: item.tier,
                        mint: (item.nft) ? item.nft.mint : item.mint,
                        time: item.createdAt 
                    }
                    return <SpinsItem key={index} spinData={spinData} />
                })}
            </div>
        </div>
    )
}

export default LastSpins